import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roleFilter',
    standalone: false,
})
export class RoleFilterPipe implements PipeTransform {
    transform(value: boolean): string {
        if (value) {
            return '(Administrator)';
        }

        return '';
    }
}
